import {PayloadAction} from '@reduxjs/toolkit';
//types
import {
	IOrganizationTableTicketsResponse,
	IOrganizationTablesAndTicketsAvailableResponse,
	IOrganizationTicketsListReducer,
	IOrganizationTicketsListResponse,
	IOrganizationTicketsStatistics,
	IOrganizationTicketsTiers,
} from '../../utils/types';

export const pendingOperation = (state: IOrganizationTicketsListReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationTicketsListReducer) => {
	state.isLoading = false;
};

export const getTicketsListOperation = (
	state: IOrganizationTicketsListReducer,
	{payload}: PayloadAction<IOrganizationTicketsListResponse>
) => {
	state.ticketsList = payload;
	state.isLoading = false;
};

export const getTicketsTiersOperation = (
	state: IOrganizationTicketsListReducer,
	{payload}: PayloadAction<IOrganizationTicketsTiers[]>
) => {
	state.ticketsTiers = payload;
	state.isLoading = false;
};

export const getTicketsStatisticsOperation = (
	state: IOrganizationTicketsListReducer,
	{payload}: PayloadAction<IOrganizationTicketsStatistics>
) => {
	state.ticketsStatistics = payload;
	state.isLoading = false;
};

export const getTableAndTicketsAvailableOperation = (
	state: IOrganizationTicketsListReducer,
	{payload}: PayloadAction<IOrganizationTablesAndTicketsAvailableResponse>
) => {
	state.ticketsAvailable = payload;
	state.isLoading = false;
};

export const getTableTicketsOperation = (
	state: IOrganizationTicketsListReducer,
	{payload}: PayloadAction<IOrganizationTableTicketsResponse>
) => {
	state.ticketsTable = payload;
	state.isLoading = false;
};

export const clearTableTicketsOperation = (state: IOrganizationTicketsListReducer) => {
	state.ticketsTable = null;
};

export const clearTablesAndTicketsDataOperation = (
	state: IOrganizationTicketsListReducer,
	initialState: IOrganizationTicketsListReducer
) => {
	Object.assign(state, initialState);
};

export const updateStatusOperation = (
	state: IOrganizationTicketsListReducer,
	{payload}: PayloadAction<IOrganizationTableTicketsResponse>
) => {
	state.ticketsTable = payload;
	state.isLoading = false;
};

export const clearTicketsTiersOperation = (state: IOrganizationTicketsListReducer) => {
  state.ticketsTiers = null;
};

export const clearPrivateTicketsTiersOperation = (state: IOrganizationTicketsListReducer) => {
  state.privateTicketsTiers = null;
};

export const getPrivateTicketsTiersOperation = (
	state: IOrganizationTicketsListReducer,
	{payload}: PayloadAction<IOrganizationTicketsTiers[]>
) => {
	state.privateTicketsTiers = payload;
	state.isLoading = false;
};
